import { lazyLoad } from 'utils/loadable';

export const BudgetExperimentsPage = lazyLoad(
  () => import('./index'),
  module => module.BudgetExperiments,
);
